export default __webpack_public_path__ + "static/media/VU.3a20bd90.svg";